import { useEffect, useState } from "react"
import useFetch from "../../core/hooks/useFetch"
import { toast, ToastContainer } from "react-toastify"
import { Button, Container, Flex, Heading, Link, Select, Text, TextField } from "@radix-ui/themes"
import { ICompoundSubjectRights, ISubjectRights } from "../../core/types/services-types/subject-rights-types"
import SubjectRightsService from '../../core/services/SubjectRightsService'
import CompoundSubjectRightsService from "../../core/services/CompoundSubjectRightsService"
import { useNavigate, useSearchParams } from "react-router"
import { ArrowLeftIcon } from "@radix-ui/react-icons"
export default function ActionsCompoundSubjectRights() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [id, setId] = useState<string | number | null>(searchParams.get('id'))
    const [name, setName] = useState<string>('')
    const [subjectRightsId, setSubjectRightsId] = useState<string | number>()
    const [date, setDate] = useState<string>()
    const [population, setPopulation] = useState<string | number>('0')
    const [sumBudget, setSumBudget] = useState<string | number>('0')
    const [subjectRights, setSubjectRights] = useState<ISubjectRights[]>([])
    const [compoundSubjectRights, setCompoundSubjectRights] = useState<ICompoundSubjectRights>()
    const [limitSibjectRights, setLimitSubjectRights] = useState(100)
    const [pageSubjectRights, setPageSubjectRights] = useState(0)
    const [fetchAddSubjectRights, isLoading, error, errors] = useFetch(async () => {
        if(id && subjectRightsId && name && date && population && sumBudget) {
            await CompoundSubjectRightsService.Update(id, subjectRightsId, name, date, population, sumBudget)
            toast.success("Субъект права успешно сохранен!")
        }
        else if(subjectRightsId && name && date && population && sumBudget) {
            await CompoundSubjectRightsService.Add(subjectRightsId, name, date, population, sumBudget)
            toast.success("Субъект права успешно добавлен!")
        }
    })
    const [fetchCompoundSubjectRights, isLoadingFetchCompoundSubjectRights, errorFetchCompoundSubjectRights, errorsFetchCompoundSubjectRights] = useFetch(async () => {
        if(id) {
        const data = await CompoundSubjectRightsService.Get(id)
        setCompoundSubjectRights(data)
        setName(data.name)
        setSubjectRightsId(data.subject_rights_id)
        setDate(data.date)
        setPopulation(data.population)
        setSumBudget(data.sum_budget)
        }
    })
    const [fetchSubjectRights, isLoadingFetchSubjectRights, errorFetchSubjectRights, errorsFetchSubjectRights] = useFetch(async () => {
        const data = await SubjectRightsService.GetAll(limitSibjectRights, pageSubjectRights)
        setSubjectRights(data)
    })
    useEffect(() => {
        fetchCompoundSubjectRights()
    }, [id])
    useEffect(() => {
        fetchSubjectRights()
    }, [])
    useEffect(() => {
        if (error) toast.error(error)
    }, [error])
    return (
        <Container className="wrapper pt-10">
            <ToastContainer />
            <Container className="shadow-xl p-10"> 
            <Link href="#" className="!flex !items-center" onClick={() => navigate(-1)}><ArrowLeftIcon /> Назад</Link>
            <Heading>
                Новый Состав Субъекта права
            </Heading>
            <Container className="form mb-5">
                <Container className="mb-5"> 
                <Text>Название</Text>
                <TextField.Root placeholder="Тип субъекта права" value={name} onChange={e => setName(e.currentTarget.value)}>
                </TextField.Root>
                </Container>
                <Container className="mb-5"> 
                <Text>Дата</Text>
                <TextField.Root type="date" placeholder="СССР" value={date} onChange={e => setDate(e.currentTarget.value)}>
                </TextField.Root>
                </Container>
                <Container className="mb-5"> 
                <Text>Население</Text>
                <TextField.Root type="number" placeholder="10000" value={population} onChange={e => setPopulation(e.currentTarget.value)}>
                </TextField.Root>
                </Container>
                <Container className="mb-5"> 
                <Text>Сумма бюджета</Text>
                <TextField.Root type="number" placeholder="1200000" value={sumBudget} onChange={e => setSumBudget(e.currentTarget.value)}>
                </TextField.Root>
                </Container>
                <Flex direction={'column'} className="mb-5"> 
                <Text>Субъект права</Text>
                  <Select.Root 
                    size='3' 
                    disabled={isLoadingFetchCompoundSubjectRights}
                    defaultValue={`${subjectRights.length && subjectRights[0].id}`}
                    value={`${subjectRightsId}`}
                    onValueChange={e => setSubjectRightsId(e)}
                    >
                    <Select.Trigger />
                        <Select.Content>
                            {subjectRights.map(item => {
                                return <Select.Item value={`${item.id}`}>{item.name}</Select.Item>
                            })}
                        </Select.Content>
                    </Select.Root>
                </Flex>
            </Container>
            <Button variant="solid" color='grass' loading={isLoading} onClick={async () => await fetchAddSubjectRights()}>Сохранить</Button>
            </Container>
        </Container>
    )
}